export const homepageScope = 'app.containers.HomePage';
